import { useState, useEffect } from 'react';
import { standardDrawing } from '@moleculeone/draw';

import { useSmilesToMol } from '../../../hooks';
import { BaseCompound, BaseCompoundProps } from './BaseCompound';

export interface CompoundProps extends Omit<BaseCompoundProps, 'drawnMol'> {
  smiles: string;
  renderDelay?: number;
}

export function Compound(props: CompoundProps) {
  const { smiles, renderDelay, ...restProps } = props;

  const [drawnMol, setDrawnMol] = useState<any>(null);
  const { mols } = useSmilesToMol({ smiles: [smiles], delay: renderDelay });

  const [mol] = mols ?? [];

  useEffect(() => {
    if (!mol) {
      return;
    }
    const nextDrawnMol = standardDrawing(mol);
    setDrawnMol(nextDrawnMol);
  }, [mol]);

  if (!drawnMol) {
    return null;
  }

  return <BaseCompound {...restProps} drawnMol={drawnMol} />;
}
